import React from 'react';
import SideBar from '../../base/modelLib/SideBar';

const LoraSideBar = React.memo((props) => {
  return <SideBar {...props} />;
});

export default LoraSideBar;
